import {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './Installation.rt';
import pageHeaderTemplate from './InstallationPageHeader.rt';
import {EditorFooter as pageFooterTemplate} from '../PageLayout';
import * as actions from '../../actions';
import {getFilteredInstallationGroups, selectSearchTerm} from './InstallationSelector';
import {getFilteredPendingInstallationGroups} from './NewInstallationGroup/NewInstallationGroupSelector';
import * as editorNames from '../../constants/editorNames';
import {fetchData} from '../ProjectScope/ProjectScopeActions';
import _ from 'lodash';


function mapStateToProps(state) {
  const installationGroups = getFilteredInstallationGroups(state);
  const pendingInstallationGroups = getFilteredPendingInstallationGroups(state) || [];
  const term = selectSearchTerm(state);
  return {
    installationGroups: _.sortBy(installationGroups, i => i.customDisplayName || i.name),
    pendingInstallationGroups,
    term
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchFabricator: () => dispatch(fetchData('Installation')),
    loadFeatureInclusionPresets: () => dispatch(actions.featureInclusion.loadPreset()),
    setSearchTerm: (term) => dispatch(actions.setSearchTerm(term)),
    onLoadEditor: () => dispatch(actions.loadEditor(editorNames.INSTALLATION_GROUP)),
    onUnloadEditor: () => dispatch(actions.unloadEditor())
  };
}

class installation extends PureComponent {
  update = () => this.forceUpdate();
  fetchAndUpdate = () => this.props.fetchFabricator().then(this.update);

  componentWillMount() {
    this.props.onLoadEditor();
    this.props.fetchFabricator().catch(console.error);
    document.addEventListener("newInstallationGroupAdded", this.update);
    document.addEventListener('post-save-transient', this.fetchAndUpdate);
  }

  componentWillUnmount() {
    this.props.setSearchTerm('');
    this.props.onUnloadEditor();
    document.removeEventListener("newInstallationGroupAdded", this.update);
    document.removeEventListener('post-save-transient', this.fetchAndUpdate);
  }

  render = template
}

installation.propTypes = {
  fetchFabricator: PropTypes.func.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  onLoadEditor: PropTypes.func.isRequired,
  onUnloadEditor: PropTypes.func.isRequired
};

const Installation = installation;
const InstallationPageHeader = pageHeaderTemplate;
const InstallationPageFooter = pageFooterTemplate;

const connector = connect(mapStateToProps, mapDispatchToProps);
const InstallationContainer = connector(Installation);
const InstallationPageHeaderContainer = connector(InstallationPageHeader);
const InstallationPageFooterContainer = connector(InstallationPageFooter);

export {
  Installation,
  InstallationContainer,
  InstallationPageHeader,
  InstallationPageHeaderContainer,
  InstallationPageFooter,
  InstallationPageFooterContainer
};
